import { BaseKey } from '@refinedev/core';
import { AxiosInstance } from 'axios';

import FileData from '@/model/General/FileData';
import { Ticket } from '@/model/Ticket/Ticket';

import TicketApi from './TicketApi';

class TicketRepository {
  ticketApi: TicketApi;

  constructor(axiosInstance: AxiosInstance) {
    this.ticketApi = new TicketApi(axiosInstance);
  }

  filesManagement = async (files: FileData[], ticketId: BaseKey) => {
    try {
      const filesToUpload = files.filter(file => !file.removed && file.blobFile);
      const filesToRemove = files.filter(file => file.removed);
      const promises: Promise<any>[] = [];

      if (filesToUpload.length > 0) {
        promises.push(this.ticketApi.uploadFiles(filesToUpload, ticketId));
      }

      if (filesToRemove.length > 0) {
        promises.push(this.ticketApi.removeFiles(filesToRemove, ticketId));
      }

      await Promise.all(promises);
    } catch (error) {
      console.error('Error uploading files:', error);
      throw error;
    }
  };

  updateTicket = async (ticketData: Partial<Ticket>) => {
    try {
      const response = await this.ticketApi.updateTicket(ticketData);

      return response;
    } catch (error) {
      console.error('Error updating ticket:', error);
      throw error;
    }
  };
}

export default TicketRepository;
